<template>
  <div class="pt-20 p-4 flex flex-col items-center bg-light-bg dark:bg-dark-bg min-h-screen text-light-text dark:text-dark-text">
    <AppSidebar />

    <div class="w-full max-w-6xl bg-white dark:bg-dark-box-bg rounded-lg shadow-md p-6 mt-6">
      <button
          @click="goToPassengers"
          class="mb-4 text-teal-700 dark:text-teal-400 hover:underline flex items-center"
      >
        &larr; Wróć do zakładki pasażerowie
      </button>

      <div v-if="passenger">
        <h2 class="text-2xl font-bold mb-6">Profil Pasażera</h2>

        <!-- Passenger Information Grid -->
        <div class="grid grid-cols-1 md:grid-cols-2 gap-y-4 gap-x-6 mb-6">
          <div class="space-y-2">
            <p><strong>Imię i nazwisko:</strong> {{ passenger.firstName }} {{ passenger.lastName }}</p>
            <p><strong>ID:</strong> {{ passenger.id }}</p>
            <p><strong>Telefon:</strong> {{ passenger.phone || 'Nie podano' }}</p>
          </div>
          <div class="space-y-2">
            <p><strong>Miasto:</strong> {{ passenger.city || 'Nie podano' }}</p>
            <p><strong>Adres zamieszkania:</strong> {{ passenger.homeAddress || 'Nie podano' }}</p>
            <p><strong>Adres pracy:</strong> {{ passenger.workAddress || 'Nie podano' }}</p>
          </div>
        </div>

        <hr class="my-6 border-light-border dark:border-dark-border">

        <!-- Assigned Orders Table -->
        <h4 class="text-lg font-semibold mb-4">Przypisane Zamówienia</h4>
        <div class="overflow-x-auto">
          <table class="w-full border-collapse border border-light-border dark:border-dark-border">
            <thead>
            <tr class="bg-light-table-header dark:bg-dark-table-header">
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">#</th>
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Numer Zamówienia</th>
              <th class="border border-light-border dark:border-dark-border px-4 py-2 text-left">Data</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(orderPassenger, index) in passenger.orderPassengers"
                :key="orderPassenger.id"
                class="hover:bg-light-hover dark:hover:bg-dark-hover cursor-pointer"
                @click="goToProfile(orderPassenger.order)"
            >
              <td class="border border-light-border dark:border-dark-border px-4 py-2">{{ index + 1 }}</td>
              <td class="border border-light-border dark:border-dark-border px-4 py-2 text-teal-700 dark:text-teal-400 hover:underline">
                Zamówienie #{{ orderPassenger.order.mpk }}
              </td>
              <td class="border border-light-border dark:border-dark-border px-4 py-2">
                {{ new Date(orderPassenger.order.date).toLocaleDateString() }}
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Loading State -->
      <div v-else-if="loading" class="text-gray-500 dark:text-gray-400">
        <p>Ładowanie szczegółów pasażera...</p>
      </div>

      <!-- Error State -->
      <div v-else-if="errorMessage" class="text-red-500 dark:text-red-400">
        <p>{{ errorMessage }}</p>
      </div>
    </div>
  </div>
</template>




<script>
  import { useAuthStore } from '@/stores/authStore';
  import passengersService from '@/services/passengersService';
  import AppSidebar from '@/components/AppSidebar.vue';

  export default {
    name: 'PassengerProfile',
    components: {AppSidebar},
    data() {
      return {
        passenger: null,
        loading: true,
        errorMessage: '',
      };
    },
    setup() {
      const authStore = useAuthStore();
      authStore.checkExpiration();
      return { user: authStore.user };
    },
    mounted() {
      this.fetchPassenger();
    },
    methods: {
      async fetchPassenger() {
        const passengerId = this.$route.params.id; // Pobieramy id z parametrów URL
        try {
          const response = await passengersService.getPassengerById(passengerId);
          this.passenger = response.data;
          this.loading = false;
        } catch (error) {
          this.errorMessage = 'Error fetching passenger details. Please try again.';
          this.loading = false;
        }
      },
      goToPassengers() {
        const currentPage = this.$route.query.currentPage;

        if (this.user.role === 'ROLE_ADMIN') {
          this.$router.push({name: 'PassengersPageAdmin', query: {currentPage: currentPage} });
        } else {
          this.$router.push({name: 'PassengersPageDispatcher', query: {currentPage: currentPage} });
        }
      },
      goToProfile(order) {
        if (this.user.role === 'ROLE_ADMIN') {
          this.$router.push({
            name: 'OrderProfileAdmin', 
            params: {id: order.id},
            query: { 
              returnTo: this.$route.name,
              passengerId: this.passenger.id,
            }
          });
        } else {
          this.$router.push({
            name: 'OrderProfileDispatcher', 
            params: {id: order.id},
            query: { 
              returnTo: this.$route.name,
              passengerId: this.passenger.id,
            }
          });
        }
      },
    }
  };
  </script>